// @flow
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import { Typography } from "src/latest/src/components";
import './drop-down-menu.scss';

type Props = {
    className: string,
    variant?: string,
    onClick: Function,
    menu: Array<Object>,
    toggler: string,
    title?: string,
    isProcessing?: boolean,
    isActivityLog?: boolean
}

export default function DropDownMenu({ className, variant = 'primary', onClick, menu, toggler, title, isProcessing = false, isActivityLog = false }: Props): React$Element<any> {
    return (
        <Dropdown className={`drop-down-menu ${className}`}>
            <Dropdown.Toggle variant={variant} disabled={isProcessing}>
                {
                    isActivityLog ? <div className='drop-down-menu__activity-log'>
                        <div>
                            {
                                title && <Typography color='color-28' weight='bold' className='title'>{title}</Typography>
                            }
                            {toggler}
                        </div>

                        {
                            isProcessing && <Spinner
                                animation='border'
                                role='status'
                                variant='dark'
                                className='drop-down-menu__spinner'/>
                        }
                    </div> : <>
                        {
                            title && <Typography color='color-28' weight='bold' className='title'>{title}</Typography>
                        }
                        {toggler}
                    </>
                }

            </Dropdown.Toggle>
            <Dropdown.Menu>
                {
                    menu.map((m, i) => <Dropdown.Item className='drop-down-menu-item cursor-pointer' key={i} onClick={() => onClick(m.value)}>
                        <Typography
                            color='color-2'
                            weight={'semi-bold'} variant='size-16'>
                            {m.title}
                        </Typography>
                    </Dropdown.Item>)
                }
            </Dropdown.Menu>
        </Dropdown>
    );
}
